import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../environments/environment';

/**
 * ChatbotEnabledGuard - Restringe una ruta a entornos donde el chatbot está
 * habilitado (environment.chatbotEnabled), igual que el widget flotante.
 */
export const ChatbotEnabledGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (environment.chatbotEnabled) {
    return true;
  }

  return router.createUrlTree(['/access-denied']);
};
